module.exports = __webpack_public_path__ + "static/media/delux03.744b5db3.png";